import { Component, OnInit, AfterContentChecked, Input, Output, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Settings, AppSettings } from '../../../app.settings';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { Router } from '@angular/router';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SidenavMenuService } from '../sidenav-menu/sidenav-menu.service';
import { EventEmitter } from '@angular/core';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { ActivatedRoute} from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styles: [
    `.menu-title {
      color: darkgray !important;
      pointer-events: none;
      text-decoration: none;
    }`,
    `.menu-item:hover, .menu-item.active {
      background-color: antiquewhite !important;
    }`,
    `.pl-5 {
      padding-left: 5px;
    }`,
    `@media (max-width: 600px) {
      .increaseIcon {
        font-size: 26px !important;
        margin: 0px !important;
      }
    }`,
    `@media (max-width: 960px) {
      .increaseIcon {
        font-size: 30px;
        margin: 0 5px 5px 0;
      }
    }`,
    `.userDetailsWithStoreCredit{
      display: flex;
      justify-content: space-between;
      align-items: end;
      flex-direction: column;
    }`,
    `.userDetailsWithStoreCredit .StoreCreditDisplay{
      color:#111;
    }`,
  ]
})
export class TopMenuComponent implements OnInit, OnDestroy {
  public loggedIn = false;
  public currencies = ['USD', 'EUR'];
  public currency: any;
  public userDetails: any;
  sub;
  @Input('menuItems') menuItems: [];
  @Input('menuParentId') menuParentId;
  @Output() emitPass: EventEmitter<any> = new EventEmitter()
  public flag: any;
  loginSubService;
  public settings: Settings;
  featureTags = {};
  increaseAccountIcon;
  storeDetails = {};
  private readonly isBrowser;

  constructor(
    private sidenavMenuService: SidenavMenuService,
    public router: Router,
    public appSettings: AppSettings,
    public apiService: ApiService,
    private notification: NotificationService,
    private subscription: SubscriptionService,
    public sharedDataService: SharedDataService,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);      
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {
    /******* login action completed after get user details in top menu********/
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
    this.loginSubService = this.apiService.getLogin().subscribe(data => {
      this.loggedIn = data.loggedIn;
      this.userDetails = data.userDetails;
    }, err => { });
    /******* end********/
    /******* page refreshed after get user details in top menu********/
    this.loggedIn = this.apiService.loggedIn();
    if(!!this.featureTags && !this.featureTags['sf_enhance_registration_membership']){
      this.getUserDetails();      
    }
    /******* end********/
    this.sub = this.subscription.getSubject().subscribe(val => {
      if (val['getUser']) {
        this.getUserDetails();
      }
    });
    this.increaseAccountIcon = this.checkFeatureFlag();
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
        this.storeDetails = this.route.snapshot.data['store']['response']['data']['store'];
    }
  }
  checkFeatureFlag(): boolean {
    return !!this.featureTags && this.featureTags['sf_header_icon_small_and_alignment_correction'];
  }
  getUserDetails() {
    if(this.isBrowser){
    this.apiService.getAutheticatedUserDetails().subscribe(data => {
      if (data['response']['status'] === 1) {
        this.userDetails = data['response']['data']['users'];
        // Set Delivery Address Details for Delivery Calendar
        this.subscription.setUserAddressDetails(this.userDetails);
      }
    }, err => { })
  }

  }
  ngOnDestroy() {
    !!this.sub && this.sub.unsubscribe();
    !!this.loginSubService && !!this.loginSubService.unsubscribe();
  }
  public logout() {
    this.apiService.logout().subscribe(data => {
      if (data['response']['status'] === 1) {
        localStorage.clear();
        // sessionStorage.clear();
        this.apiService.setLogin({
          loggedIn: false,
          userDetails: null
        });
        this.subscription.subjectNext({ msg: 'logged out' });
        this.sharedDataService.cartDataSource.next(false)
        var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
        this.router.navigate(['/sign-in'], queryParams);
        this.notification.success(data['response']['message'], 5000);
      } else {
        this.notification.error(data['response']['message'], 5000);
      }
    }, err => { console.log('get user details error', err) })
  }

  handleChange(event) {
    try {
      let sessionRestore = ["store", "storeLinks","featureTags"]; //"featureTags"
      let sessionRestoreArray = {};
      if (event["href"] && event["href"] === "sign-in") {
        var queryParams = this.router.url.includes("cart")
          ? { queryParams: { redirectURL: this.router.url } }
          : {};
        this.router.navigate(["/sign-in"], queryParams);
      } else if (event["name"] && event["name"] === "Logout") {
        this.apiService.logout().subscribe(
          (data) => {
            if (data["response"]["status"] === 1) {
              sessionRestore.forEach((element) => {
                sessionRestoreArray[element] =
                  sessionStorage.getItem(element);
              });
              // sessionStorage.clear();
              sessionStorage.removeItem('booking_start_date');
              sessionStorage.removeItem('calendar_data_last');
              sessionStorage.removeItem('cardEnable');
              sessionStorage.removeItem('cart');
              sessionStorage.removeItem('cutoff');
              sessionStorage.removeItem('order_exist');
              sessionStorage.removeItem('cardEnable');
              sessionStorage.removeItem('recurring_frequencies');
              sessionStorage.removeItem('selected_delivery_calendar');
              sessionStorage.removeItem('selected_delivery_date');
              sessionStorage.removeItem('event_details');
              sessionStorage.removeItem('upcoming_event_dates');
              if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
                sessionStorage.removeItem('user_event_ids');
              }
              if (!!this.featureTags && this.featureTags['ftags_membership']) {
                sessionStorage.removeItem('membership_item');
              }
              localStorage.clear();
              this.apiService.setLogin({
                loggedIn: false,
                userDetails: null,
              });
              this.resetSession(sessionRestoreArray);
              this.subscription.subjectNext({ msg: "logged out" });
              this.sharedDataService.cartDataSource.next(false);
              // window.location.reload();
              var queryParams = this.router.url.includes("cart")
                ? { queryParams: { redirectURL: this.router.url } }
                : {};
              this.router.navigate(["/sign-in"], queryParams);
              this.notification.success(
                data["response"]["message"],
                5000
              );
            } else {
              this.notification.error(
                data["response"]["message"],
                5000
              );
            }
          },
          (err) => {
            console.log("get user details error", err);
          }
        );
      } else {
        this.emitPass.emit(event);
      }
    } catch (error) {
      console.log(error);
    }
  }

  resetSession(sessionRestoreArray) {
    try {
      for (let [key, value] of Object.entries(sessionRestoreArray)) {
        sessionStorage.setItem(key, JSON.stringify(JSON.parse(value as string)));
      }
    } catch (error) {
      console.log(error)
    }
  }

  goToSignIn(link: HTMLAnchorElement, event: Event) {
    event.preventDefault();
    if (!this.router.url.includes('sign-in')) {
      var queryParams = this.router.url.includes('cart') ? { queryParams: { 'redirectURL': this.router.url } } : {};
      this.router.navigate(['/sign-in'], queryParams);
      link.href = '/new/path';
    }
  }
}
